// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../editing/widgets/WidgetTags.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* What a Map Editor node puts over the Autark map it edits on (#662): only a
   tip with its buttons, on the dark of Curio's menus
   (components/menus/darkMenu.module.css); the map draws the tools itself.
   Buttons are the Widgets tab's (WidgetTags.module.css). */

.svqNBqWmIb9MxvE1mfzQ {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.X63Jguy6uJlJBmmgc0v9 {
  cursor: crosshair;
}

/* The tip and its buttons, at the map's top left, past Autark's menu button
   (40px square, 10px in from the corner). */
.wCVvQryzPC5JvmA_c2Aw {
  --widget-h: 22px;
  position: absolute;
  left: 58px;
  top: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  pointer-events: auto;
  font-family: var(--curio-font-family);
}

.bACRmR0VDnF7KCciEsbP {
  padding: 4px 8px;
  border: 1px solid var(--curio-border-context-menu);
  border-radius: var(--curio-radius-sm);
  background: var(--curio-top-bar-bg);
  box-shadow: var(--curio-shadow-context-menu);
  color: var(--curio-text-on-dark);
  font-size: var(--curio-font-size-sm);
  line-height: 1.4;
}

.cp_mNlzuRqFRa0Bhq6P2 {
}
`, "",{"version":3,"sources":["webpack://./src/components/editFeatures/MapEditOverlay.module.css"],"names":[],"mappings":"AAAA;;;2DAG2D;;AAE3D;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;4CAC4C;AAC5C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,qCAAqC;EACrC,mCAAmC;EACnC,4CAA4C;EAC5C,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;AAEA","sourcesContent":["/* What a Map Editor node puts over the Autark map it edits on (#662): only a\n   tip with its buttons, on the dark of Curio's menus\n   (components/menus/darkMenu.module.css); the map draws the tools itself.\n   Buttons are the Widgets tab's (WidgetTags.module.css). */\n\n.overlay {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.drawing {\n  cursor: crosshair;\n}\n\n/* The tip and its buttons, at the map's top left, past Autark's menu button\n   (40px square, 10px in from the corner). */\n.toolbar {\n  --widget-h: 22px;\n  position: absolute;\n  left: 58px;\n  top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  pointer-events: auto;\n  font-family: var(--curio-font-family);\n}\n\n.tip {\n  padding: 4px 8px;\n  border: 1px solid var(--curio-border-context-menu);\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-top-bar-bg);\n  box-shadow: var(--curio-shadow-context-menu);\n  color: var(--curio-text-on-dark);\n  font-size: var(--curio-font-size-sm);\n  line-height: 1.4;\n}\n\n.button {\n  composes: button from \"../editing/widgets/WidgetTags.module.css\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `svqNBqWmIb9MxvE1mfzQ`,
	"drawing": `X63Jguy6uJlJBmmgc0v9`,
	"toolbar": `wCVvQryzPC5JvmA_c2Aw`,
	"tip": `bACRmR0VDnF7KCciEsbP`,
	"button": `cp_mNlzuRqFRa0Bhq6P2 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`
};
export default ___CSS_LOADER_EXPORT___;
